const convertLoginResponse = (response) => ({
  accessToken: response.access_token,
  refreshToken: response.refresh_token,
  tokenType: response.token_type,
});

export default convertLoginResponse;
